(function () {
  'use strict';

  var isProductPage = document.body && document.body.classList.contains('template-product');
  var productPagePosition = isProductPage
    ? '.pizzannu-inbox-icon-only { position: fixed !important; right: 14px !important; left: auto !important; bottom: calc(118px + env(safe-area-inset-bottom, 0px)) !important; z-index: 2147483001 !important; }'
    : '';

  var styleText = '@media (max-width: 749px) {' +
    '.pizzannu-inbox-icon-only { font-size: 0 !important; width: 48px !important; min-width: 48px !important; padding-left: 0 !important; padding-right: 0 !important; justify-content: center !important; gap: 0 !important; }' +
    '.pizzannu-inbox-icon-only .pizzannu-inbox-label { display: none !important; }' +
    '.pizzannu-inbox-icon-only svg, .pizzannu-inbox-icon-only img { width: 24px !important; height: 24px !important; }' +
    productPagePosition +
    '}';

  function isInboxContext(element) {
    var node = element;
    while (node) {
      var name = [node.id, node.className, node.tagName, node.localName].filter(Boolean).join(' ').toLowerCase();
      if (/shopify-chat|shopify-inbox|inbox|chat/.test(name)) return true;
      node = node.parentNode || node.host;
    }
    return false;
  }

  function addStyle(root) {
    if (!root || root.querySelector('[data-pizzannu-inbox-mobile-style]')) return;
    var style = document.createElement('style');
    style.dataset.pizzannuInboxMobileStyle = 'true';
    style.textContent = styleText;
    if (root.nodeType === 9) root.head.appendChild(style);
    else root.appendChild(style);
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.nodeType === 9 || root.nodeType === 11) addStyle(root);

    root.querySelectorAll('button, [role="button"], a').forEach(function (element) {
      if (!isInboxContext(element)) return;
      var label = (element.textContent || '').trim().toLowerCase();
      if (label !== 'help' && label !== 'support') return;

      element.classList.add('pizzannu-inbox-icon-only');
      Array.from(element.children).forEach(function (child) {
        var childText = (child.textContent || '').trim().toLowerCase();
        if ((childText === 'help' || childText === 'support') && !child.querySelector('svg, img')) {
          child.classList.add('pizzannu-inbox-label');
        }
      });
    });

    root.querySelectorAll('*').forEach(function (element) {
      if (element.shadowRoot) scan(element.shadowRoot);
    });
  }

  function start() {
    scan(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 || node.nodeType === 11) scan(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
